export const korean = {
  Add_Account: "새 계정 추가",
  Select_Language: "언어 선택",
  Welcome_to_BOSAGORA_Wallet: "Welcome to BOSAGORA Wallet",
  Secure_Easy_to_Use_Crypto_Wallet: "Secure & Easy to Use Crypto Wallet",
  Welcome_to_New_Wallet: "새로운 계정 생성을 진행하겠습니다",
  Follow_these_steps_to_create_a_new_wallet:
    "새로운 계정을 생성하기 위해 다음 단계를 수행하십시오",
  Secret_Seed_or_Public_Key: "비밀키 혹은 공개키",
  Select_Account: "추가할 계정을 선택하세요",
  Select_Account_not_registered: "추가할 수 있는 계정이 없습니다",
  Enter_seed_or_public_Mandotary: "비밀키 혹은 공개키를 입력하십시오 (필수)",
  Wallet_Name: "계정 이름 (선택)",
  Secret_Key: "비밀키",
  Public_Key: "공개키",
  Create_Wallet: "새 계정 생성",
  Create: "비밀키 생성",
  Wallet_Note:
    "비밀키를 안전하게 저장하십시오. 비밀키를 누구에게도 보여주지 마십시오.",
  Confirm: "확인",
  Recent_Transactions: "최근 트랜잭션",
  Overview: "개요",
  Unfreezing: "언프리징",
  UTXO: "UTXO",
  Filter: "필터",
  Transaction_type: "트랜잭션 유형",
  Block_height: "블록 높이",
  Time: "시간",
  Peer: "상대방 주소",
  Account: "계정",
  Lock_period: "잠금 기간",
  Pending_Transactions: "보류 트랜잭션",
  Submission_time: "전송 시간",
  Block_delay: "블록 지연",
  Target: "받는 주소",
  Block_Height: "블록 높이",
  Outbound_transaction: "출금 트랜잭션",
  From: "시작일",
  To: "종료일",
  Peer_Name: "상대방 연락처명",
  Download: "다운로드",
  Inbound_transaction: "입금 트랜잭션",
  Fee: "수수료",
  Action: "기능",
  Transaction_History: "트랜잭션 내역",
  Receiver: "받는 주소",
  Address: "주소",
  Sender: "보내는 주소",
  Add_Sender: "보내는 주소 추가",
  Drawn: "인출할 금액",
  Remaining: "필요한 금액",
  Transaction_Fee: "트랜잭션 수수료",
  NEXT: "다음",
  Transaction_Overview: "트랜잭션 개요",
  Transaction_Details: "상세 트랜잭션 내역",
  Senders_Detail: "보내는 주소",
  Receivers_Detail: "받는 주소",
  Transactions_History: "트랜잭션 내역",
  Total_Amount: "총 금액",
  Amount: "금액",
  Drawn_Amount: "인출될 금액",
  Back: "취소",
  Transaction_has_been_successful: "트랜잭션이 성공적으로 전달되었습니다",
  Create_Validator: "검증자 생성",
  Freezing_Amount: "프리징 금액",
  units_to_Stake_for_Flash: "Validator 스테이킹 단위 (0~996)",
  Add: "추가하기",
  Send_BOA: "BOA 전송",
  Store_Data: "데이터 저장",
  Settings: "설정",
  This_page_allows_you_to_create_contacts:
    "이 페이지에서 연락처를 생성할 수 있습니다. 각 주소에 이름을 부여하여 보다 쉽게 사용할 수 있습니다.",
  Add_Contact: "연락처 추가",
  Contacts: "연락처 목록",
  Contact_Name_Table: "연락처 이름",
  Contact_Name: "연락처 이름 (선택 항목)",
  Actions: "기능",
  Contact_List: "연락처 목록",
  Total: "전체 잔고",
  Spendable: "지출가능 잔고",
  Spendable_Balance: "지출 가능한 잔고",
  Balance: "전체 잔고",
  Info: "정보",
  Contact_Name_Required:
    "연락처 이름은 필수 입력 사항은 아니지만, 편의를 위해 사용하는 것을 추천합니다.",
  Cancel: "취소",
  Language: "언어",
  Dark_Mode: "다크 모드",
  Endpoints: "Endpoints",
  Sending_Delay: "송신 지연",
  Timezone: "시간대",
  Set_Wallet_Name: "계정 이름 설정",
  Manage: "관리",
  Reset_Wallet_State: "월렛 상태 초기화",
  Clear: "삭제",
  Edit: "수정",
  CoinNet: "CoinNet",
  TestNet: "TestNet",
  Self_Balance: "선택계정 잔액",
  Total_Balance: "전체계정 잔액",
  Mode_status: "모드 상태",
  Save: "저장",
  sorry_no_data: "데이터가 없습니다",
  Contact_address_already_exist: "이 주소를 가진 연락처는 이미 존재합니다.",
  clear_all_states_wallet:
    "월렛의 모든 상태를 지우시겠습니까? 저장된 모든 설정과 계정이 지워집니다.",
  Edit_Contact_Name: "계정 이름 수정",
  Frozen_Amount: "프리징 금액",
  Amount_Unfrozen: "언프리징 금액",
  Pending_Transaction_Overview: "보류 트랜잭션 개요",
  Cancellation_Transaction_Overview: "취소 트랜잭션 개요",
  Payload_Fee: "페이로드 요금",
  Freezing_Fee: "프리징 수수료",
  Cancel_Transaction: "트랜잭션 취소",
  Input_payload: "입력 페이로드(Base64)",

  About_Wallet: "BOSAGORA Wallet에 대한 안내",
  About_Wallet_LineOne:
    "보스아고라 월렛은 브라우저를 통해 보스아고라 네트워크와 연결되는 도구(Tool)입니다.",
  About_Wallet_LineTwo:
    "보스아고라 월렛은 블록체인 어플리케이션 개발을 지원하기 위해 만들어졌으며, 일반 사용자를 위한 서비스를 목표로 출시 되지는 않았습니다.",
  About_Wallet_LineThree:
    "보스아고라 월렛을 사용하고자 한다면, 아래 “책임의 한계” 와 “보안에 대한 중요 알림” 을 반드시 숙독하시기 바랍니다. 보스아고라 월렛을 사용하려면 블록체인에 대한 기본적인 이해가 반드시 필요합니다.",
  Disclaimer: "책임의 한계",
  Disclaimer_LineOne:
    "보스아고라는 월렛을 현재 상태대로 제공하며 기능의 정상적 수행을 포함하여 그 어떠한 것도 보증하지 않습니다.",
  Disclaimer_LineTwo:
    "보스아고라는 월렛의 장애 또는 외부의 간섭 및 영향 없는 정상적 수행을 보장하지 않으며 월렛 상에서 발견된 장애를 수정할 책임을 지지 않습니다.",
  Disclaimer_LineThree:
    "보스아고라는 어떠한 경우에도 월렛의 사용으로 인하여 귀하에게 직접 또는 간접적으로 발생하는 피해 및 물적 손실 등에 대한 배상 책임을 지지 않습니다.",
  Disclaimer_LineFour:
    "귀하는 보스아고라 월렛의 사용에 동의함으로써 스스로의 결정에 따라 위와 같은 위험을 인식하고 부담한 것으로 간주됩니다.",
  Important_Notice: "보안에 대한 중요 알림",
  Important_Notice_LineOne:
    "보스아고라 월렛은 귀하의 웹 브라우저, 컴퓨터 운영체제, 또는 컴퓨터 장비의 보안 취약점을 통해 귀하의 정보를 탈취하려하는 공격으로부터 귀하의 정보를 보호할 수 없습니다.",
  Important_Notice_LineTwo:
    "보스아고라 월렛은 귀하의 private key를 로컬 컴퓨터, 모바일 기기, 보스아고라 network 등 어느 곳에도 저장하고 있지 않습니다.",
  Important_Notice_LineThree:
    "보스아고라 월렛 또는 보스아고라는 귀하의 비밀키가 분실될 경우 이를 복구할 수 없습니다. 따라서 보스아고라는 귀하가 비밀키를 반드시 네트워크에 연결되지 않은 안전한 저장소에 보관할 것을 강력히 권장합니다.귀하의 관리 미숙 또는 소홀로 인하여 정보 손실이 발생할 경우, 귀하의 디지털 자산에 돌이킬 수 없는 피해가 발생할 수 있습니다.",
  I_agree: "위 내용에 동의합니다. ",
  Accept: "동의하기",
  Validator_Address: "검증자의 주소",
  New_Secret_Key: "비밀키",
  Keypair_Validator: "비밀키 생성",
  Select_Unfreezing: "언프리징을 위해 UTXO를 선택하십시오.",
  Add_New: "새로운 계정 추가",
  Yes: "예",
  No: "아니요",
  Ok: "확인",
  Useful_Info_Line1: "주소(공개키)에 해당하는 비밀키를 입력하세요.",
  Useful_Info_Line2: "비밀키는 BOA 전송에 필수입니다.",
  Useful_Info_Line3: "비밀키는 로컬 컴퓨터에 저장되지 않습니다.",
  Useful_Info_Line4:
    "비밀키 또는 공개키는 트랜잭션 생성에 필수적입니다. 비밀키 또는 공개키는 로컬 컴퓨터에 저장되지 않습니다.",
  Amount_is_not_enough: "금액이 충분하지 않습니다",
  Address_is_already_added: "주소가 이미 추가되었습니다.",
  Enter_a_valid_receiver_address_first:
    "먼저 유효한 수신자 주소를 입력하십시오.",
  Enter_a_valid_Base64_format: "유효한 Base64 형식을 입력하세요.",
  Enter_a_valid_payload_length:
    "페이로드의 최대 입력값은 1024bytes 를 넘길수 없습니다. (입력길이:{{length}} bytes)",
  Option: "옵션",
  Account_already_register_with_this_address:
    "계정이 이미 이 주소로 등록되어 있습니다.",
  This_key_is_not_valid: "이 키는 유효하지 않습니다.",
  Enter_units_to_stake_for_flash_upto_100:
    "Validator 에 대해 프리징할 단위를 최대 100까지 입력하십시오.",
  Enter_units_to_stake_for_flash_upto_996:
    "0 부터 최대 996까지 입력 가능합니다.",
  Send: "발송",
  Previous: "이전",
  Create_Send_Transaction:
    "보내는 주소와 받는 주소가 동일한 트랜잭션을 만들어 보냅니다.",
  New_Cancellation_Transactions:
    "이전에 전송된 트랜잭션이 블록에 저장되어 있으면 새로운 취소 트랜잭션은 무시될 수 있습니다.",
  Press_Cancellation_Transactions:
    "이 트랜잭션을 취소하려면 아래의 “트랜잭션 취소” 버튼을 누르십시오.",
  Fee_Error: "수수료는 0.01보다 작을 수 없습니다.",
  Light_Mode: "라이트 모드",
  Error_in_Encryption: "암호화 오류입니다.",
  Invalid_Fee: "유효하지 않은 수수료.",
  Invalid_default_fee: "잘못된 기본 수수료입니다.",
  Invalid_Address: "잘못된 주소.",
  Something_went_wrong: "문제가 발생했습니다.",
  Account_with_this_name_is_already_added:
    "이 이름의 계정이 이미 추가되었습니다.",
  Contact_with_this_name_already_exists: "이 이름의 연락처가 이미 있습니다.",
  You_cant_add_your_own_address_to_contact_list:
    "연락처 목록에 자신의 주소를 추가할 수 없습니다.",
  Enter_valid_receiver_address_first: "먼저 유효한 수신자 주소를 입력하십시오.",
  Address_not_found: "주소를 찾을 수 없습니다",
  Coinbase_transaction_cannot_be_canceled:
    "Coinbase 트랜잭션은 취소할 수 없습니다.",
  Unfreeze_transaction_cannot_be_canceled:
    "언프리징 트랜잭션은 취소할 수 없습니다.",
  Key_not_found: "키를 찾을 수 없습니다.",
  Token_not_found: "토큰을 찾을 수 없습니다.",
  Transaction_fee_must_be_equal_or_greater_than_0:
    "트랜잭션 수수료는 0보다 크거나 같아야 합니다.",
  Requested_amount_should_not_be_less_than_BOA:
    "요청 금액은 0 BOA 보다 크야 됩니다.",
  Data_size_cannot_be_greater_than_maximum:
    "데이터 크기는 최대값보다 클 수 없습니다",
  Insufficient_balance: "잔액이 부족합니다.",
  The_transaction_is_invalid_cannot_be_canceled:
    "트랜잭션이 잘못되었습니다. 취소할 수 없습니다.",
  Not_enough_fee_to_cancel_pending_transaction:
    "보류 트랜잭션을 취소하기에 수수료가 충분하지 않습니다.",
  Problem_occurred_while_applying_transaction_cancellation:
    "트랜잭션 취소를 적용하는 동안 문제가 발생했습니다.",
  Field: "필드",
  Transaction_moved_from_pending: "이 트랜잭션은 보류 상태에서 이동되었습니다.",
  Are_you_sure_you_want_to_delete_this_address: "삭제하시겠습니까?",
  Are_you_sure_you_want_to_delete_this_account: "이 계정을 삭제하시겠습니까?",
  Are_you_sure_you_want_to_delete_the_selected_senders_address:
    "선택한 보내는 주소를 삭제하시겠습니까?",
  Changes_exist_Are_you_sure_you_want_to_cancel:
    "변경 사항이 있습니다. 정말 취소 하시겠습니까?",
  The_amount_to_be_transferred_has_not_been_filled_yet:
    "이체할 금액이 아직 채워지지 않았습니다.",
  Please_check_the_amount_again: "금액을 다시 확인해주세요.",
  Copied: "복사됨",
  High: "높음",
  Medium: "중간",
  Low: "낮음",
  Enter_Address: "주소 입력",
  Payload: "페이로드",
  Local_Time: "현지 시각",

  //SDK Types Message
  Success: "성공",
  FailedAccessToAgora: "Agora에 액세스하지 못했습니다.",
  FailedAccessToStoa: "Stoa에 접근하지 못했습니다.",
  FailedRequestHeight: "블록 높이에 대한 요청을 처리하지 못했습니다.",
  FailedRequestBalance: "계정 잔액 요청을 처리하지 못했습니다.",
  FailedRequestUTXO: "UTXO에 대한 요청을 처리하지 못했습니다.",
  FailedRequestUTXOInfo: "UTXO 정보에 대한 요청을 처리하지 못했습니다.",
  FailedRequestTransactionHistory: "트랜잭션 대한 요청을 처리하지 못했습니다.",
  FailedRequestTransactionPending:
    "보류 트랜잭션 목록에 대한 요청을 처리하지 못했습니다.",
  FailedRequestTransactionDetail:
    "트랜잭션 세부 정보에 대한 요청을 처리하지 못했습니다.",
  FailedRequestTransactionOverview: "트랜잭션 대한 요청을 처리하지 못했습니다.",
  FailedRequestTransaction: "트랜잭션 요청을 처리하지 못했습니다.",
  FailedRequestPendingTransaction:
    "보류 트랜잭션에 대한 요청을 처리하지 못했습니다.",
  FailedRequestTxFee: "트랜잭션 수수료 요청을 처리하지 못했습니다.",
  FailedRequestVotingFee: "투표료 요청을 처리하지 못했습니다.",
  FailedVerifyPayment: "트랜잭션 지불 확인 요청을 처리하지 못했습니다.",
  NotExistReceiver: "수신기가 없습니다.",
  NotEnoughAmount: "양이 부족합니다.",
  Cancel_NotAllowCoinbase: "코인베이스 유형의 트랜잭션은 취소할 수 없습니다.",
  Cancel_InvalidTransaction: "올바른 트랜잭션이 아닙니다.",
  Cancel_NotAllowUnfreezing: "언프리징 트랜잭션은 취소할 수 없습니다.",
  Cancel_NotFoundUTXO: "UTXO 정보를 찾을 수 없습니다.",
  Cancel_UnsupportedLockType:
    "취소기능에 사용될 수 없는 LockType을 가지고 있습니다.",
  Cancel_NotFoundKey: "비밀키를 찾을 수 없습니다.",
  Cancel_NotEnoughFee: "취소 수수료가 충분하지 않습니다.",
  Cancel_NotAssignedTx: "트랜잭션이 할당되지 않았습니다.",
  Cancel_CancellationTx: "이미 취소된 트랜잭션 입니다. 재전송하시겠습니까?",

  NotAssignedReceiver: "받는 주소의 정보가 할당되지 않았습니다.",
  NotAssignedReceiverAmount: "수취인 금액이 할당되지 않았습니다.",
  InsufficientAmount: "금액이 부족합니다.",
  ExistUnknownSecretKey: "암호 키를 알 수 없는 계정이 있습니다.",
  NotAssignedSender: "보내는 주소의 정보가 할당되지 않았습니다.",
  AmountIsZero: "전송할 금액이 0입니다.",
  FailedBuildTransaction: "트랜잭션을 작성하는 과정에서 예외가 발생했습니다.",
  FailedSendTx: "전송 트랜잭션을 처리하지 못했습니다.",
  Unfreeze_UnsupportedLockType: "입력한 UTXO의 키 형식이 지원되지 않습니다.",
  Unfreeze_NotUTXOOwnedAccount: "등록된 계정이 소유한 UTXO가 아닙니다.",
  Unfreeze_NotFrozenUTXO: "입력한 UTXO가 프리징된 것이 아닙니다.",
  Unfreeze_NotFoundUTXO:
    "입력한 UTXO에 대한 정보를 서버에서 찾을 수 없습니다. 이미 사용 중인지 확인해 주세요.",
  Unfreeze_AlreadyAdded: "입력한 UTXO는 이미 추가되었습니다.",
  Unfreeze_NotAssignedUTXO: "프리징 UTXO가 추가되지 않았습니다.",
  Unfreeze_ExistNotFrozenUTXO:
    "입력한 UTXO 중에는 프리징 되지 않은 것이 있습니다.",
  InvalidPublicKey: "올바른 공개키가 아닙니다.",
  InvalidPublicKeyLength: "올바른 공개키 길이가 아닙니다.",
  InvalidPublicKeyFormat: "올바른 공개키 형식이 아닙니다.",
  InvalidSecretKey: "올바른 비밀키가 아닙니다.",
  InvalidSecretKeyLength: "올바른 비밀키 길이가 아닙니다.",
  InvalidSecretKeyFormat: "올바른 비밀키 형식이 아닙니다.",
  InvalidKeyPair: "올바른 키페어가 아닙니다.",
  InvalidHash: "올바른 해시가 아닙니다.",
  InvalidHashLength: "올바른 해시 길이가 아닙니다.",
  InvalidHashFormat: "올바른 해시 형식이 아닙니다.",
  InvalidAmount: "이것은 유효한 금액이 아닙니다.",
  InvalidAmountFormat: "올바른 금액 형식이 아닙니다.",
  UnknownError: "알 수 없는 오류가 발생했습니다.",
  SystemError: "시스템 오류가 발생했습니다.",

  No_Response_URL:
    "응답이 없는 주소입니다. 활성화된 서버의 주소를 입력해주세요.",
};
